export class BeneficioClientesVulnerablesCovid19 {
  _id_cliente_vulnerable_covid19: Number;
  criterio_beneficio_covid19: String;
  rut: String;
  nombre: String;
  telefono: String;
  email: String;
  numero_cliente: String;
  direccion: String;
  id_comuna: String;
  id_region: String;
  motivo_imposibilidad_pago: String
  numero_cuotas: Number
  id_tipo_institucion: String;
  archivo_cedula_identidad: String;
  archivo_cedula_identidad_reverso: String;
  archivo_acreditacion_residencia: String;
  archivo_registro_social_hogares: String;
  archivo_solicitud_activacion_seguro_cesantia: String;
  archivo_reduccion_suspension_jornada_laboral: String;
  archivo_certifica_trabajador_independiente: String;
  archivo_imposibilidad_pago: String;
  archivo_situacion_vulnerabilidad: String;
  archivo_finiquito_carta_despido: String;
  archivo_declaracion_jurada_simple: String;
  archivo_exposicion_fundada_solicitud: String;
  archivo_personeria: String;
  acepto_condiciones: Boolean;
  acepto_postergacion_pago: Boolean;
  acepto_newsletters: Boolean;
  acepto_boleta_electronica: Boolean;
  acepto_privacidad: Boolean;
  token: String;
}